export default "__VITE_ASSET__D1Wlvpxf__"